/// 顶部 --- 统计数据
export const totalConfig = {
  "MN0糖系列铺市率": "43%",
  // "YLD总品项": "74%",
  // "JLB总品项": "1.0%",
  "YL0糖系列铺市率": "1.0%"
}

/// ----
export const tableDataArr1 = {
  "product": ["07-01","07-02","07-03","07-04","07-05","07-06","07-07","07-08"],
    "MN0糖系列铺市率": [46,40,51,47,40,45,38,39],
    "YL0糖系列铺市率": [71,79,74,77,82,67,61,75],
    // "JLB总品项": [0,6,6,9,3,9,2,0],
    // "YLD总品项": [1,8,0,9,0,8,9,7]
}

export const tableDataArr2 = {
  "MN0糖系列铺市率": [66,44,54,69,79,54,42,63,33,25,34,54],
  // "product": ["北京","东北","华北","华东","华南","华中","闽赣","山东","上海","西北","西南","豫皖"],
  "product": ["北京","西北","豫皖","山东","华中","东北","华北","华东","上海","华南","西南","闽赣"],
  "YL0糖系列铺市率": [77,62,62,50,62,72,73,64,84,72,56,53],
  // "JLB总品项": [0,5,2,1,0,0,1,1,0,0,1,0],
  // "YLD总品项": [0,1,0,1,0,0,1,1,0,0,1,0],
  }

export const tableDimensionArr = ["product", "MN0糖系列铺市率", "YL0糖系列铺市率"]

///
export const modernChartDataArr = [
  {
    "type": "line",
    "barWidth": "70%",
    "label": {
      "normal": {
        "show": true,
        "color": "black",
        "fontSize": 10,
        "position": "inside"
      }
    },
    "animationDuration": 2800,
    "animationEasing": "cubicInOut"
  },
  {
    "type": "line",
    "barWidth": "70%",
    "label": {
      "normal": {
        "show": true,
        "color": "black",
        "fontSize": 10,
        "position": "inside"
      }
    },
    "animationDuration": 2800,
    "animationEasing": "cubicInOut"
  },
  // {
  //   "type": "line",
  //   "barWidth": "70%",
  //   "label": {
  //     "normal": {
  //       "show": true,
  //       "color": "black",
  //       "fontSize": 10,
  //       "position": "inside"
  //     }
  //   },
  //   "animationDuration": 2800,
  //   "animationEasing": "cubicInOut"
  // },
  // {
  //   "type": "line",
  //   "barWidth": "70%",
  //   "label": {
  //     "normal": {
  //       "show": true,
  //       "color": "black",
  //       "fontSize": 10,
  //       "position": "inside"
  //     }
  //   },
  //   "animationDuration": 2800,
  //   "animationEasing": "cubicInOut"
  // },
  // {
  //   "type": "line",
  //   "barWidth": "70%",
  //   "label": {
  //     "normal": {
  //       "show": true,
  //       "color": "black",
  //       "fontSize": 10,
  //       "position": "inside"
  //     }
  //   },
  //   "animationDuration": 2800,
  //   "animationEasing": "cubicInOut"
  // },
  // {
  //   "type": "line",
  //   "stack": "vistors",
  //   "barWidth": "70%",
  //   "label": {
  //     "normal": {
  //       "show": true,
  //       "color": "black",
  //       "fontSize": 10,
  //       "position": "inside"
  //     }
  //   },
  //   "animationDuration": 2800,
  //   "animationEasing": "cubicInOut"
  // }
]





// WEBPACK FOOTER //
// ./src/components/kpi/config/TwentyAvgGoods.js